var _ellipse, _circle, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.00046,
    cy: 1.95651,
    rx: 1.95651,
    ry: 1.95651,
    fill: "#5F6F7C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00046,
    cy: 8.99997,
    r: 1.95651,
    fill: "#5F6F7C"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.00046,
    cy: 16.0434,
    rx: 1.95651,
    ry: 1.95651,
    fill: "#5F6F7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisIcon);
export default __webpack_public_path__ + "static/media/ellipsis-icon.0f13c6966dff02642830d66caa4fa790.svg";
export { ForwardRef as ReactComponent };